// Vuetify
import "vuetify/styles";
import { createVuetify, type ThemeDefinition } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi-svg";
import { ColourPalette } from "@esenda/core-ui/constants";
import {
    CHECKOUT_THEME_NAME,
    DEFAULT_THEME_NAME,
} from "@/theme/applyCheckoutTheme";

export const lightTheme: ThemeDefinition = {
    dark: false,
    colors: {
        primary: ColourPalette.PRIMARY_400,
        secondary: ColourPalette.CYAN,
        tertiary: ColourPalette.MAGENTA,
        white: ColourPalette.WHITE,
        dark: ColourPalette.INK,
        "gradient-dark": ColourPalette.GRADIENT_DARK,
        "slate-grey": ColourPalette.SLATE_GREY,
        background: ColourPalette.APP_BACKGROUND,
        success: ColourPalette.SUCCESS_500,
        warning: ColourPalette.WARNING_50,
        error: ColourPalette.RED_500,
        disabled: ColourPalette.DISABLED_BG,
    },
};

/**
 * lightTheme stays the default and is never modified. When a checkout theme is
 * present it is registered as a second theme that App.vue applies to v-app,
 * leaving lightTheme available for shielded areas (footer, legal pages).
 */
export function createAppVuetify(
    checkoutColors?: Readonly<Record<string, string>>,
) {
    const themes: Record<string, ThemeDefinition> = {
        [DEFAULT_THEME_NAME]: lightTheme,
    };

    if (checkoutColors) {
        themes[CHECKOUT_THEME_NAME] = {
            ...lightTheme,
            colors: {
                ...lightTheme.colors,
                ...checkoutColors,
            },
        };
    }

    return createVuetify({
        theme: {
            defaultTheme: DEFAULT_THEME_NAME,
            themes,
        },
        components,
        directives,
        icons: {
            defaultSet: "mdi",
            aliases,
            sets: {
                mdi,
            },
        },
        defaults: {
            VSelect: {
                transition: false,
                menuProps: {
                    transition: false,
                },
            },
            VAutocomplete: {
                transition: false,
                menuProps: {
                    transition: false,
                },
            },
            VCombobox: {
                transition: false,
                menuProps: {
                    transition: false,
                },
            },
        },
    });
}
